var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportVehicleFab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 23,
    viewBox: "0 0 51 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.427509 14.4369C0.620003 13.5129 0.889496 12.6082 1.65947 11.9537C2.23695 11.4725 2.4102 10.895 2.2562 10.1635C1.96746 8.79681 2.17921 7.5071 2.91068 6.31363C3.21867 5.7939 3.52666 5.27416 3.81541 4.77368C3.25717 4.56193 4.72013 2.11726 5.8366 1.88626C8.93576 1.23178 12.0542 0.731296 15.1918 0.519553C17.4633 0.365557 19.7539 0.346308 22.0446 0.30781C24.1236 0.269311 26.164 0.6158 28.1082 1.42428C29.9369 2.175 31.4961 3.34922 33.1323 4.40794C34.8455 5.50516 36.6934 6.27513 38.7339 6.52537C40.3316 6.71787 41.9485 6.83337 43.4885 7.3531C45.6444 8.08458 47.4539 9.23954 48.5126 11.3377C48.9553 12.204 49.4173 13.0124 50.245 13.5707C50.322 13.6284 50.3798 13.8017 50.3605 13.8979C50.3028 14.6871 50.245 15.4956 50.168 16.2848C50.091 17.1511 50.091 18.0365 49.5521 18.8065C49.1286 19.4225 48.3008 19.8075 47.6271 19.6535H46.7416C46.2219 21.4437 44.6049 22.7141 42.6415 22.6756C40.7358 22.7334 39.0996 21.3282 38.5799 19.5765L10.9184 19.3262C10.5142 21.3089 8.80101 22.6949 6.76057 22.7141C4.62388 22.6949 2.92993 21.2319 2.56419 19.2492H1.71722C0.735497 19.2492 0.562252 19.1338 0.35051 18.229C0.0617676 16.9586 0.177265 15.7074 0.446754 14.4561L0.427509 14.4369Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportVehicleFab);
export default __webpack_public_path__ + "static/media/support-vehicle-fab.fcefae0b5ce04bd5241b461141e03403.svg";
export { ForwardRef as ReactComponent };